
/* Delegated listener also supports Theme Editor section reloads. */
document.addEventListener('click', function(event){
  const button=event.target.closest('[data-b-view]');
  if(!button)return;
  const gallery=button.closest('[data-b-gallery]');
  const photo=gallery.querySelector('.b-tour-image');
  const view=button.dataset.bView;
  if(!photo||!photo.dataset[view])return;
  photo.src=photo.dataset[view];
  photo.alt=photo.dataset[view+'Alt'];
  gallery.querySelectorAll('[data-b-view]').forEach(control=>control.setAttribute('aria-pressed',String(control===button)));
});
